import "preact/debug"

import Navbar from "./components/Navbar"
import Router from "preact-router"
import { createHashHistory } from "history"
import { Room } from "./components/Room"
import { render } from "preact"
import rooms from "./components/rooms"

import "./styles.css"
import { trackEvent } from "src/utils/analytics"
import { ElfsightPopup } from "src/utils/fw"
import { optedIn } from "./constants"
import { CometChat, CometChatIcon } from "./components/CometChat"

const handleNewRoute = ({ previous, url }) => {
	if (
		window.dataLayer[0]["Registrant Type"] === "Non-Member"
		&& !["/atrium"].includes(url)
		&& !url.match(/exhibition-hall/)
		&& !url.match(/Booth-(One|Two|Three)/)
	) {
		route(previous || "/atrium")
	}
	// if (["/lounge"].includes(url)) route("/Atrium") // Redirect to home after venue closes

	// JS time works in milliseconds so for a 2h timeout we need:
	// 1000 ms per second * 3600 s per hour * 2 hours
	if (window.lastPageLoad && window.lastPageLoad < new Date() - 1000 * 3600 * 2) {
		window.location = "https://isfcongress.tkeventsregistration.com/2022/"
		route(previous)
	}

	window.lastPageLoad = new Date()
	trackEvent({
		eventID: 67089,
		from: previous?.replace(/^\//g, "").replace(/^$/g, "Atrium") || null,
		to: url.replace(/^\//g, "").replace(/^$/g, "Atrium"),
		type: "Venue Navigation",
		userID: window.dataLayer[0]["Registrant ID"],
	})
}

const elfsightPopups = [
	{
		ID: "8a3b257b-724b-43f5-8fcc-e238b50e2513",
		trigger: "IMB-consent"
	},
	{
		ID: "0ad79e26-9e8f-454e-a1d6-a8642199dec5",
		trigger: "Huawei"
	},
	{
		ID: "789ef6d0-2772-4888-821b-86474e19ffc1",
		trigger: "IBM"
	},
	{
		ID: "ccec1287-11fb-4ee4-b0e1-075a97384b05",
		trigger: "Algosec"
	},
	{
		ID: "5c7c9a1f-eb27-4d5f-8be5-cf16cc55a5f2",
		trigger: "Crowdstrike"
	},
	{
		ID: "76f3d697-0a19-493e-af70-2ddb335f0469",
		trigger: "CybelAngel"
	},
	{
		ID: "842ac27b-6519-4217-bc93-1c8043a1ddcd",
		trigger: "SecurityScorecard"
	},
	{
		ID: "a4b431b2-b46b-4fd1-80da-046be18f036e",
		trigger: "BlueVoyant"
	},
	{
		ID: "7ee985ec-7210-4cc4-bddf-e78a5a360a29",
		trigger: "SureCloud"
	},
	{
		ID: "baa177b2-f0b9-4fd1-840b-6df5becfc2db",
		trigger: "KPMG"
	}
]

const App = ({links = []}) => {
    const chat = optedIn ? <CometChat /> : <CometChatIcon optinUrl="https://isfcongress.tkeventsregistration.com/2022/sign-in" bgcolor="#8f38de" />
    return <>
        <Navbar />
		{ /*chat*/ }
        <Router history={createHashHistory()} onChange={handleNewRoute}>
            {links.map(Room)}
        </Router>
		{ elfsightPopups.map(ElfsightPopup) }
        <div id="modals"></div>
        <script src="https://apps.elfsight.com/p/platform.js" defer />
    </>
}


render(<App links={rooms}/>, document.getElementById("content"));